// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html


import firebase from 'firebase/app'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyAjAARw_xqRoZvg6_WOhOWySlLAbaqWgp0",
  authDomain: "app-script-243110.firebaseapp.com",
  databaseURL: "https://app-script-243110.firebaseio.com",
  projectId: "app-script-243110",
  storageBucket: "app-script-243110.appspot.com",
  messagingSenderId: "558353622133",
  appId: "1:558353622133:web:dcffc042cd0c5a9323843c"
}

firebase.initializeApp(config)
